import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';
export const ContentContainer: FC<PropsWithChildren<{
  className?: string;
  suppressVerticalMargin?: boolean;
}>> = ({
  children,
  className,
  suppressVerticalMargin
}) => <div className={classNames(className, 'px-4 xl:px-6 print:px-0', {
  'py-4 lg:py-7': !suppressVerticalMargin
})} data-sentry-component="ContentContainer" data-sentry-source-file="content-container.tsx">
    <div className="w-full mx-auto dark:text-gray-200">{children}</div>
  </div>;